const synthetixv2 = require("./synthetix_v2");

module.exports = {
  UNIV2_ROUTER_ADDRESS: "0xe54ca86531e17ef3616d22ca28b0d458b6c89106",
  FARMS: {
    synthetixv2
  }
};
